import { Component, OnInit } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';

@Component({
  selector: 'ngx-add-comments',
  templateUrl: './add-comments.component.html',
})
export class AddCommentsComponent implements OnInit {
  jobId;
  jobcorrespondence: any = [];
  otherCorrespondence: any = [];
  formFilled: boolean = false;
  title: string;
  comments: string;
  toastrPosition: any = 'bottom-end';
  adminNotifications: any;
  id: any;
  user;

  constructor(protected ref: NbDialogRef<AddCommentsComponent>) { }

  ngOnInit() {
  }

  cancel() {
    this.ref.close({ submit: false, comments: null });
  }

  submit() {
    this.ref.close({ submit: true, comments: this.comments });
  }



  update(ref) {
    ref.close({send: true});
  }

  dontUpdate(ref) {
    ref.close({send: false});
  }

}
